<template>
  <div>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-patient-card-edit"
      ok-only
      centered
      size="lg"
      :title="createMode ? 'Add Patient Card' : 'Edit Add Patient Card'"
      @ok="submitItem()"
    >
      <b-card-text>
        <b-row>
          <b-col md="12">
            <b-form-group label="Patient' Companion Name" label-for="Name">
              <b-form-input
                id="Name"
                v-model="EditForm.full_companion_name"
                placeholder="Enter Patient Name"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="Phone Number" label-for="phoneNumber">
              <VuePhoneNumberInput
                v-model="EditForm.companion_phone"
                @update="
                  (obj) => {
                    showPhoneObj(obj, 'countryCallingCode');
                  }
                "
                default-country-code="IQ"
                :error="
                  EditForm.companion_phone
                    ? isNotValid || EditForm.companion_phone[0] != 0
                    : false
                "
              />
              <p v-if="errorForm.companion_phone" class="ml-25 error">
                This field is required.
              </p>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Patient Type" label-for="Type">
              <v-select
                v-model="EditForm.type"
                :options="['IN', 'OUT', 'EMERGENCY', 'CLINIC', 'LAB']"
                placeholder="Patient Type"
              />
            </b-form-group>
          </b-col>
          <div
            v-if="EditForm.type === 'IN'"
            class="mt-2 mt-md-0 w-100 mx-1"
            v-for="(item, index) in doctors"
            :key="index"
          >
            <b-row>
              <b-col md="10" cols="12">
                <AutoComplete
                  :label="$t('clinic.doctors-name')"
                  :placeholder="$t('clinic.doctors-name')"
                  v-model="doctors[index]"
                  :serializer="(val) => val.id"
                  param-query="search"
                  endpoint="doctor"
                  text-title="name"
                />
              </b-col>

              <b-col class="d-flex align-items-center w-full" md="2" cols="12">
                <b-button
                  class="mx-1 w-full"
                  variant="primary"
                  size="sm"
                  @click="addDoctor"
                  >+</b-button
                >
                <b-button
                  :disabled="index === 0"
                  size="sm"
                  variant="danger"
                  @click="removeDoctor(index)"
                  >X</b-button
                >
              </b-col>
            </b-row>
          </div>
          <b-col v-if="EditForm.type === 'IN'" md="12" cols="12">
            <AutoComplete
              :label="$t('reception.room')"
              :placeholder="$t('reception.room')"
              v-model="EditForm.room_id"
              :serializer="(val) => val.id"
              param-query="search"
              endpoint="available-room"
              text-title="name"
            />
          </b-col>
          <b-col md="6" cols="12">
            <b-form-group
              :label="$t('reception.patient-case')"
              label-for="patient_case"
            >
              <b-form-input
                id="patient_case"
                v-model="EditForm.patient_case"
                :placeholder="$t('reception.patient-case')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6" cols="12">
            <b-form-group
              :label="$t('reception.diagnosis')"
              label-for="diagnosis"
            >
              <b-form-input
                id="diagnosis"
                v-model="EditForm.diagnosis"
                :placeholder="$t('reception.diagnosis')"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-patient-visit-hospital"
      ok-only
      centered
      size="lg"
      :title="$t('reception.Add_Visit_To_Hospital_Number')"
      @ok="submitVistNumber()"
    >
      <b-card-text>
        <b-row>
          <b-col md="12">
            <b-form-group
              :label="$t('reception.VisitـHospitalـNumber')"
              label-for="number_of_stays_before_activating_the_system"
            >
              <b-form-input
                id="number_of_stays_before_activating_the_system"
                v-model="number_of_stays_before_activating_the_system"
                placeholder="Enter Visit Hospital Number"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-confirmation-stop-card"
      ok-only
      centered
      size="lg"
      @ok="stopCard"
      :title="$t('reception.stop-card')"
    >
      <b-card-text>
        <b-row>
          <b-col md="12">
            <h3 class="text-center text-danger">
              {{ $t("reception.stop-card-message") }}
            </h3>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer>
        <b-button variant="primary" @click="stopCard" block>{{
          $t("reception.stop-card")
        }}</b-button>
      </template>
    </b-modal>

    <b-card>
      <b-button
        @click="changeRoom()"
        variant="warning"
        class="p-1 mb-1"
        block
        v-if="$store.state.app.permissions.includes('store-patientCard')"
      >
        {{ $t("reception.change-patient-room") }}
      </b-button>
      <b-button
        @click="changeSurgery()"
        variant="outline-warning"
        class="p-1 mb-1"
        block
        v-if="$store.state.app.permissions.includes('store-patientCard') && surgeries && surgeries.length > 0"
      >
        {{ $t("common.change-surgery") }}
      </b-button>
      <b-button
        @click="show(EditForm, 'create')"
        variant="success"
        class="p-1 mb-1"
        block
        v-if="$store.state.app.permissions.includes('store-patientCard')"
      >
        {{ $t("reception.add-patient-card") }}
      </b-button>
      <!-- Button: Create card -->

      <b-row v-if="patientCard">
        <b-col cols="12" md="12">
          <!-- Button: stop card -->
          <b-button
            @click="showConfirmationModal"
            variant="danger"
            class="p-1"
            block
          >
            {{ $t("reception.stop-card") }}
          </b-button>
        </b-col>
        <!-- Button: go to invouce -->
        <!-- <b-col cols="12" class="mt-1">
          <b-button
            v-if="
              $store.state.app.permissions.includes('get-invoice') &&
              showPrivewInvoice
            "
            variant="outline-secondary"
            block
            class="p-1"
            @click="
              $router.push({
                name: 'invoices',
                params: { patientId: patientCard.patient_id },
                query: {
                  patientCardId: patientCard.id,
                },
              })
            "
          >
            {{ $t("hospital.preview-invoices") }}
          </b-button>
        </b-col> -->
      </b-row>
      <b-button
        v-if="patientCardData && !patientCard"
        @click="printInpatientForm"
        variant="warning"
        class="p-1 mb-1 mt-1"
        block
      >
        {{ $t("reception.print-inpatient-form") }}
      </b-button>
      <b-button
        v-if="patientCardData && !patientCard"
        @click="showVistNumberModel()"
        variant="primary"
        class="p-1 mb-1"
        block
      >
        {{ $t("reception.add-patient-visit-number") }}
      </b-button>
    </b-card>
    <ReceptionPatientCardWithQR
      :patientCard="latest_unactive_patient_card"
      :is_unactive_card_qr="true"
    />
    <vue-html2pdf
      v-if="patientCardData && !patientCard"
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="patient card"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="currentPatientPdf"
    >
      <section
        dir="rtl"
        class="pdf-content font-modify my-5 mx-5"
        slot="pdf-content"
      >
        <b-row class="mx-5 my-3">
          <b-col cols="6" class="d-flex flex-column align-items-end">
            <span>مستشفى الوزيرية الاهلي</span>
            <span class="mx-1">دائرة صحة الرصافة</span>
          </b-col>
          <b-col cols="6" class="d-flex flex-column">
            <span> دائرة الصحة </span>
            <span>دائرة التخطيط واتمتة الموارد</span>
            <span>قسم الاصحاء الصحي والحياتي</span>
            <span>خاص بالحاسبة الالكترونية</span>
          </b-col>
        </b-row>
        <!-- <div class="d-flex flex-column align-items-end mx-5 text-center">s</div> -->
        <table class="border border-2 border-dark">
          <b-row class="mx-0 px-0 d-flex flex-column justify-content-end">
            <b-col cols="12">
              <b-row>
                <b-col
                  class="border border-2 border-dark d-flex justify-content-center align-items-center"
                  cols="1"
                >
                  <span class="rotated-text"
                    >تملئ المعلومات من قبل الممرضة</span
                  >
                </b-col>
                <b-col style="margin: 0; padding: 0" cols="11">
                  <div>
                    <!-- dsdsds -->
                    <div class="start-box">
                      <section>
                        <div class="col-12 px-0 d-flex justify-content-center">
                          <div class="mx-5">استمارة المريض الراقد</div>
                        </div>
                        <div class="col-12 d-flex" style="margin-top: 1px">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>

                        <div class="col-12 d-flex justify-content-center">
                          1 -
                          <div>رقم التسجيل الطبي للمريض</div>
                        </div>
                        <div class="col-12 d-flex" style="margin-top: 4px">
                          <div
                            v-for="(digit, index) in paddedPatientNo"
                            :key="index"
                            style="
                              width: 30px !important;
                              height: 20px;
                              font-weight: bold;
                            "
                            class="square-dark border border-2 border-dark text-center font-bold"
                          >
                            {{ digit }}
                          </div>
                        </div>
                        <!-- <div class="col-12 d-flex" style="margin-top: 4px">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          >
                            {{ patientCardData.patient.patient_no }}
                          </div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div> -->
                      </section>
                      <div class="col-8 mb-2">
                        <table style="color: #000">
                          <tr>
                            <td>
                              <span>2 -</span>
                              <span> رقم الوحدة الطبية </span>
                            </td>
                            <td>
                              <span>3 -</span>
                              <span> اختصاص الوحدة الطبية</span>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                    <!-- dsdsds -->
                  </div>

                  <!-- line one -->

                  <table
                    class="mt-4 font-modify"
                    style="color: #000; width: 100%"
                  >
                    <tr class="pdf-table">
                      <th class="no-border">
                        4-الموقع:{{ patientCardData.patient.district_name }}
                      </th>
                      <th class="no-border">
                        الناحية: {{ patientCardData.patient.town_name }}
                      </th>
                      <th class="no-border">
                        القضاء: {{ patientCardData.patient.judiciary_name }}
                      </th>
                      <th class="no-border font-modify">
                        المحافظة:
                        {{ governorateName }}
                      </th>
                      <td class="square-dark"></td>
                      <td class="square-dark"></td>
                      <td class="square-dark"></td>
                      <td class="square-dark"></td>
                      <td class="square-dark"></td>
                      <td class="square-dark"></td>
                      <td></td>
                    </tr>
                  </table>
                  <!-- end line one -->
                  <!-- line two -->
                  <table style="width: 100%">
                    <div
                      class="d-flex justify-content-between w-100"
                      style="color: #000"
                    >
                      <div class="no-border w-50 text-left px-1">
                        5-اسم المريض الرباعي: {{ patientCardData.patient.name }}
                      </div>

                      <div
                        class="square-dark border border-2 border-dark w-25"
                        style="height: 20px"
                      ></div>
                    </div>
                  </table>
                  <!-- end line two -->
                  <!-- line three -->

                  <table style="width: 100%">
                    <div
                      class="d-flex justify-content-between w-100"
                      style="color: #000"
                    >
                      <div class="no-border w-50 text-left px-1">
                        6-اسم الام الثلاثي:
                        {{ patientCardData.patient.mother_name }}
                      </div>

                      <div
                        class="square-dark border border-2 border-dark w-25"
                        style="height: 20px"
                      ></div>
                    </div>
                  </table>
                  <table style="width: 100%">
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1">
                            7-الجنس:
                            {{
                              patientCardData.patient.gender === "Male"
                                ? "ذكر"
                                : "انثى"
                            }}
                          </div>
                          <div class="no-border mx-2">
                            8-التحصيل الدراسي:
                            {{ patientCardData.patient.education_level }}
                          </div>
                          <div class="no-border mx-2">
                            9-المولد: {{ patientCardData.patient.birth_date }}
                          </div>
                        </div>
                        <div class="col-4 d-flex">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <!-- end line 3 -->
                  <!-- line 4 -->

                  <!-- end line 4 -->
                  <!-- line 5 -->
                  <table style="width: 100%">
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1">
                            10-العمر: {{ patientAge }}
                          </div>
                          <div class="no-border mx-2">
                            11-الحالة الزوجية:
                            {{ patientCardData.patient.marital_status }}
                          </div>
                        </div>
                        <div class="col-4 d-flex">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <table style="color: #000; width: 100%">
                    <tr class="pdf-table">
                      <th class="no-border">12-محل الاقامة:</th>
                      <th
                        class="no-border"
                        v-if="patientCardData.patient.residence_type === 'city'"
                      >
                        مدن
                      </th>
                      <th
                        class="no-border"
                        v-if="
                          patientCardData.patient.residence_type ===
                          'countryside'
                        "
                      >
                        ريف
                      </th>
                      <th class="no-border">
                        المحافظة :
                        <span>{{ governorateName }}</span>
                      </th>
                      <th class="no-border">
                        القضاء :
                        <span>{{
                          patientCardData.patient.judiciary_name
                        }}</span>
                      </th>
                      <th class="no-border">
                        الناحية
                        <span>{{ patientCardData.patient.town_name }}</span>
                      </th>
                      <td class="square-dark"></td>
                      <td></td>
                      <td class="square-dark"></td>
                      <td class="square-dark"></td>
                      <td class="square-dark"></td>
                      <td class="square-dark"></td>
                      <td class="square-dark"></td>
                    </tr>
                  </table>
                  <!-- end line 6 -->
                  <!-- line 7-->
                  <table style="width: 100%">
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters py-1">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div
                            class="no-border mx-1 d-flex flex-column align-items-start justify-content-between"
                          >
                            13-السجل المدني :

                            <div>
                              14- رقم البطاقة الموحدة:
                              {{ patientCardData.patient.national_id }}
                            </div>
                          </div>
                          <div
                            class="no-border mr-2 d-flex flex-column align-items-start justify-content-between"
                          >
                            <div>
                              رقم الصحيفة:
                              {{ patientCardData.patient.document_page_number }}
                            </div>
                            <div>
                              رقم السجل:
                              {{ patientCardData.patient.document_number }}
                            </div>
                            <div>
                              دائره الاحوال المدنية:
                              {{
                                patientCardData.patient
                                  .department_of_civil_status
                              }}
                            </div>
                          </div>
                          <div class="no-border mx-2">
                            الجنسية: {{ patientCardData.patient.national_id }}
                          </div>
                        </div>
                        <div class="col-4 d-flex align-items-center">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <!-- end line 7-->
                  <!-- line 8 -->
                  <table style="width: 100%">
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1">
                            15-تاريخ الدخول:
                            {{ formatDate(patientCardData.created_at) }}
                          </div>
                        </div>
                        <div class="col-4 d-flex">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <!-- end line 8 -->
                  <!-- line 9-->
                  <table style="width: 100%">
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters py-1">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1">16-هل المريض:</div>
                          <div
                            class="no-border mx-2 d-flex flex-column align-items-start justify-content-between"
                            style="height: 70px"
                          >
                            <div>مدخن</div>
                            <div>مصاب بالسكر</div>
                            <div class="no-border">مصاب بارتفاع ضغط الدم</div>
                            <div class="no-border">لدية امراض القلب</div>
                          </div>
                          <div
                            class="no-border mx-2 d-flex flex-column justify-content-between"
                            style="height: 70px"
                          >
                            <div v-for="i in 4" :key="i">نعم</div>
                          </div>
                          <div
                            class="no-border mx-2 d-flex flex-column justify-content-between"
                            style="height: 70px"
                          >
                            <div v-for="i in 4" :key="i">لا</div>
                          </div>
                        </div>
                        <div class="col-4">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark text-center"
                          >
                            {{
                              latest_unactive_patient_card.is_smoker
                                ? "نعم"
                                : "لا"
                            }}
                          </div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark text-center"
                          >
                            {{
                              latest_unactive_patient_card.has_diabetes
                                ? "نعم"
                                : "لا"
                            }}
                          </div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark text-center"
                          >
                            {{
                              latest_unactive_patient_card.has_high_blood_pressure
                                ? "نعم"
                                : "لا"
                            }}
                          </div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark text-center"
                          >
                            {{
                              latest_unactive_patient_card.has_heart_disease
                                ? "نعم"
                                : "لا"
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <!-- end line 9-->
                  <!-- line 10 -->
                  <table style="width: 100%">
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1">
                            17-وزن المريض: {{ patientCardData.patient.weight }}
                          </div>
                        </div>
                        <div class="col-4 d-flex">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <!-- end line 10 -->
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  class="border border-2 border-dark d-flex justify-content-center align-items-center"
                  cols="1"
                >
                  <span class="rotated-text">
                    تملئ المعلومات من قبل الطبيب المعالج
                  </span>
                </b-col>
                <b-col style="margin: 0; padding: 0" cols="11">
                  <!-- line 11 -->
                  <table style="width: 100%">
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1">
                            18-تاريخ الخروج:
                            {{
                              formatDate(
                                latest_unactive_patient_card.out_date_time
                              )
                            }}
                          </div>
                        </div>
                        <div class="col-4 d-flex">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <!-- line 12 -->
                  <table style="width: 100%; height: 50px">
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1 font-modify">
                            19- التشخيص النهائي للمرض حسب التصنيف الدولي للامراض
                            : ICD-10: {{ patientCardData.patient_case }}
                          </div>
                        </div>
                        <div class="col-4 d-flex">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <table style="width: 100%">
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters pb-1">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1">20-العمليات الجراحية</div>
                          <div
                            class="no-border mr-2 d-flex flex-column align-items-start justify-content-between"
                          >
                            <div>أ-تاريخ اجرائها</div>
                            <div>ب- نوعها</div>
                            <div>ج-درجتها</div>
                          </div>
                        </div>
                        <div class="col-4 d-flex">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <!-- end line 13-->
                  <!-- line 14 -->
                  <table style="width: 100%">
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1">صغرى - 1</div>
                          <div class="no-border mx-1">متوسطة - 2</div>
                          <div class="no-border mx-1">كبرى - 3</div>
                          <div class="no-border mx-1">فوق الكبرى - 4</div>
                          <div class="no-border mx-1">خاصة - 5</div>
                        </div>

                        <div class="col-4 d-flex">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <!-- end line 14 -->
                  <!-- line 15-->
                  <table style="width: 100%">
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters py-1">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1">
                            21- حالة المريض بعد الخروج من المستشفى:
                          </div>
                          <div
                            class="no-border mx-2 d-flex flex-column align-items-start justify-content-between"
                          >
                            <div>1 - شفاء</div>
                            <div>2 - تحسن</div>
                            <div>3 - وفاة</div>
                          </div>
                          <div
                            class="no-border mx-1 d-flex flex-column align-items-start justify-content-between"
                          >
                            <div>4 - خرج على مسؤوليتة</div>
                            <div>5 - نقل الى مسشتفى اخرى</div>
                            <div>6 - حاله اخرى</div>
                          </div>
                        </div>
                        <div class="col-4 d-flex align-items-center">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <!-- end line 15-->
                </b-col>
              </b-row>
              <!-- line 16 -->
              <b-row>
                <b-col class="" cols="1"></b-col>
                <b-col style="margin: 0; padding: 0" cols="12">
                  <table style="width: 100%">
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1">
                            22- مجموع الرقودات السابقة للمريض خلال السنة في هذه
                            المسشتفى :
                          </div>
                        </div>
                        <div class="col-4 d-flex">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark text-center"
                            v-for="num in visitNumber"
                            :key="num"
                          >
                            {{ num }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <!-- end line 16 -->
                  <!-- line 17 -->
                  <table style="color: #000; width: 100%; height: 50px">
                    <tr>
                      <th colspan="1" class="no-border">
                        اسم توقيع الممرضة المسؤولة
                      </th>
                      <th colspan="1" class="no-border">
                        اسم توقيع مسؤول الوحدة الطبية
                      </th>
                    </tr>
                  </table>
                  <!-- end line 17 -->
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </table>
        <b-row>
          <b-col cols="10">
            <div style="text-align: start">
              <div class="my-3">ملاحظة</div>
              <div class="my-3">ملاحظة</div>
            </div>
          </b-col>
          <b-col cols="2" class="mt-2">
            <div style="">
              <qrcode
                class="qrcodeStyle"
                :size="100"
                :text="`https://vesalio-private.aswar.solutions/patient-card-by-qr/${latest_unactive_patient_card.id}`"
              ></qrcode>
              <p class="text-wrap text-right" style="font-size: 10px">
                ملاحظة : هذة QR خاص بأخر بطاقة تم إيقافها للمريض
              </p>
            </div>
          </b-col>
        </b-row>
      </section>
    </vue-html2pdf>

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-change-room"
      ok-only
      centered
      size="lg"
      :title="$t('reception.change-patient-room')"
      @ok="submitChangeRoom()"
    >
      <b-card-text>
        <b-row>
          <b-col lg="6">
            <b-form-group :label="$t('reception.room')" label-for="room">
              <v-select
                v-model="changeRoomForm.room_id"
                :options="availableRooms"
                label="name"
                :reduce="(room) => room.id"
                :placeholder="$t('reception.select-room')"
              />
            </b-form-group>
          </b-col>
          <b-col lg="6">
            <b-form-group :label="$t('reception.days')" label-for="days">
              <b-form-input
                id="days"
                v-model="changeRoomForm.days"
                type="number"
                :placeholder="$t('reception.days')"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-modal
      id="modal-change-surgery"
      :title="$t('common.change-surgery')"
      ok-only
      centered
      size="lg"
      :no-close-on-backdrop="true"
    >
      <b-card-text>
        <b-row>
          <b-col>
            <h3 class="text-center">
              {{ $t("common.patient-surgery") }} :
              <span style="font-size: medium">{{
                surgeries && surgeries.length > 0 ? getNestedProperty(surgeries[surgeries.length - 1], 'surgery.title') : $t('common.no-surgery')
              }}</span>
            </h3>
          </b-col>
          <b-col md="12" cols="12" class="mt-3">
            <b-form-group :label="$t('surgery.surgery')">
              <v-select
                v-model="selectedSurgery"
                :options="availableSurgeriesOptions"
                :placeholder="$t('surgery.choose-surgery')"
                label="title"
                :reduce="(option) => option.id"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitChangeSurgery"
          class="m-0"
          :disabled="loadingChangeSurgery"
          block
        >
          <span v-if="!loadingChangeSurgery">{{ $t("common.save") }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BModal,
  BFormGroup,
  BFormInput,
  BFormTextarea, 
  BSpinner
} from "bootstrap-vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import vSelect from "vue-select";
import VueHtml2pdf from "vue-html2pdf";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import VueQRCodeComponent from "vue-qrcode-component";
import ReceptionPatientCardWithQR from "@/components/reception/ReceptionPatientCardWithQR.vue";


export default {
  components: {
    ToastificationContent,
    BRow,
    BCol,
    BCard,
    BButton,
    BFormGroup,
    BFormInput,
    VuePhoneNumberInput,
    BFormTextarea,
    vSelect,
    VueHtml2pdf,
    AutoComplete,
    qrcode: VueQRCodeComponent,
    ReceptionPatientCardWithQR,
    BSpinner
  },

  data() {
    return {
      EditForm: {
        full_companion_name: "",
        companion_phone: "",
        patient_case_details: "",
        type: "",
        patient_id: "",
        _method: "PUT",
        doctors: [],
        room_id: "",
      },
      patientCardData: {},
      createMode: false,
      errorForm: {
        full_companion_name: "",
        companion_phone: "",
        patient_case_details: "",
        type: "",
        patient_id: "",
      },
      params: {
        form: {},
        path: "",
      },
      isNotValid: false,
      number_of_total_stays_in_hospital: 0,
      number_of_stays_before_activating_the_system: 0,
      doctors: [""],
      currentDoctor: "",
      showPrivewInvoice: false,
      latest_unactive_patient_card: "",
      governorateName: "",
      changeRoomForm: {
        room_id: null,
        days: 0,
      },
      availableRooms: [],
      selectedSurgery: null,
      availableSurgeriesOptions: [],
      loadingChangeSurgery: false,
    };
  },
  props: ["patientCard", "surgeries"],

  watch: {
    patientCard: function () {
      if (!this.patientCard.is_active) {
        console.log("response3");
        return this.getPatientCard();
      }
    },
  },
  computed: {
    paddedPatientNo() {
      const patientNo = this.patientCardData.patient.patient_no.toString();
      const paddedNo = patientNo.padStart(7, "   ");
      return paddedNo.split("").reverse();
    },
    visitNumber() {
      const patientNo = this.number_of_total_stays_in_hospital.toString();
      const paddedNo = patientNo.padStart(2, "   ");
      return paddedNo.split("").reverse();
    },
    patientAge() {
      if (!this.patientCardData.patient.birth_date) return null;
      const birthDate = new Date(this.patientCardData.patient.birth_date);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();
      if (
        monthDifference < 0 ||
        (monthDifference === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      return age;
    },
  
  },
  mounted() {},
  methods: {
    getNestedProperty(obj, path, defaultValue = "") {
      const result = path
        .split(".")
        .reduce(
          (acc, part) => (acc && acc[part] ? acc[part] : defaultValue),
          obj
        );
     
      // console.log("result", result);
      return result;
    },
    showConfirmationModal() {
      this.$bvModal.show("modal-confirmation-stop-card");
    },
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          full_companion_name: "",
          companion_phone: "",
          patient_case_details: "",
          type: "",
          patient_id: this.$route.params.id,
          _method: "POST",
        };
      } else {
        this.createMode = false;

        this.EditForm.id = item.id;
        this.EditForm.full_companion_name = item.full_companion_name;
        this.EditForm.companion_phone = item.companion_phone;
        this.EditForm.patient_case_details = item.patient_case_details;
        this.EditForm.patient_id = item.patient_id;
        this.EditForm.type = this.$route.params.id;
        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-patient-card-edit");
    },
    showVistNumberModel() {
      this.$bvModal.show("modal-patient-visit-hospital");
    },
    addDoctor() {
      this.doctors.push("");
    },
    removeDoctor(index) {
      if (index === 0) return;
      this.doctors.splice(index, 1);
    },
    doctorValue(doctor, index) {
      this.currentDoctor = doctor;
      this.doctors[index] = this.currentDoctor;
    },
    stopCard() {
      this.params.path = `/stop/patientCard/${this.patientCard.id}`;
      this.params.form = this.EditForm;
      this.$store
        .dispatch("put", this.params)
        .then((response) => {
          this.showPrivewInvoice = false;
          if (this.all_response.data.status) {
            window.location.reload();
            console.log("response1");
            this.getPatientCard();
            this.$bvModal.hide("modal-confirmation-stop-card");
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Card Stopped",
                variant: "success",
              },
            });
          } else {
            this.showPrivewInvoice = true;
            // if (
            //   this.all_response.data.message ===
            //   "There are still pending invoices"
            // ) {
            //   this.$bvModal.hide("modal-confirmation-stop-card");
            // }
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: `${this.all_response.data.message}`,
                variant: "danger",
              },
            });
          }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.showPrivewInvoice = true;
            for (let item in error.response.data) {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "validation error",
                  variant: "danger",
                  text: error.response.data[item][0],
                },
              });
            }
          }
        });
    },

    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },

    submitItem() {
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }
      this.EditForm.doctors =
        this.doctors.length > 0 && this.doctors[0] !== "" ? this.doctors : [];
      console.log(
        this.doctors,
        "this.doctors;this.doctors;this.doctors;this.doctors;this.doctors;this.doctors;this.doctors;"
      );
      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/patientCard`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              window.location.reload();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/patientCard/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Patient Card Added",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
    submitVistNumber() {
      const data = {
        patient_id: this.$route.params.id,
        number_of_stays_before_activating_the_system:
          this.number_of_stays_before_activating_the_system,
      };
      (this.params.form = data),
        (this.params.path = `/patient/${this.$route.params.id}`),
        this.$store
          .dispatch("put", this.params)
          .then((response) => {
            console.log("response2");
            this.getPatientCard();
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Patient Visit Added",
                variant: "success",
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    printInpatientForm() {
      this.$refs.currentPatientPdf.generatePdf();
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
    async getPatientCard() {
      this.loading = true;
      await this.getPatient(
        `patient/${this.$route.params.id}/checkout-printable-card?include=patientCards`
      );
      // api/patient/:patient_id/checkout-printable-card
      this.loading = false;
      for (let item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }
      this.patientCardData = this.all_data.patient_cards.find(
        (x) => x.type !== "out"
      );
      console.log("this.patientCardData", this.patientCardData);
      this.number_of_total_stays_in_hospital =
        this.all_data.number_of_total_stays_in_hospital;
      this.number_of_stays_before_activating_the_system =
        this.all_data.number_of_stays_before_activating_the_system;
      this.latest_unactive_patient_card =
        this.all_data.latest_unactive_patient_card;
      this.getGovernorateName(this.all_data.governorate_id);
    },
    async getGovernorateName(governorateId) {
      try {
        const governorate = await this.getList(`governorate/${governorateId}`);
        this.governorateName = governorate.data.name;
        console.log("governorateName", this.governorateName);
      } catch (error) {
        console.error("Error fetching governorate name:", error);
        // Handle the error appropriately
      }
    },
    async changeRoom() {
      this.changeRoomForm = {
        room_id: null,
        days: 0,
      };
      console.log(
        "patientCard",
        this.patientCard.patient_room[this.patientCard.patient_room.length - 1]
          .id
      );
      try {
        // Fetch available rooms
        const response = await this.getList(
          "available-room?include=floor&take=2000"
        );
        this.availableRooms = response.data.data;
        this.$bvModal.show("modal-change-room");
      } catch (error) {
        console.error("Error fetching rooms:", error);
      }
    },
    async submitChangeRoom() {
      this.loading = true;
      try {
        const urlEncodedData = new URLSearchParams();
        urlEncodedData.append("room_id", this.changeRoomForm.room_id);
        urlEncodedData.append("days", this.changeRoomForm.days);

        await this.$store.dispatch("put", {
          form: urlEncodedData.toString(),
          path: `change-patient-room/${
            this.patientCard.patient_room[
              this.patientCard.patient_room.length - 1
            ].id
          }`,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        });

        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Room Changed",
            variant: "success",
            text: "Patient room changed successfully",
          },
        });

        this.$bvModal.hide("modal-change-room");
      } catch (error) {
        if (error.response?.status === 400) {
          for (let item in error.response.data) {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Validation Error",
                variant: "danger",
                text: error.response.data[item][0],
              },
            });
          }
        }
      } finally {
        this.loading = false;
      }
    },
    async changeSurgery() {
      this.loadingChangeSurgery = true;
      try {
        await this.getList("surgery?take=100");
        this.availableSurgeriesOptions = this.all_data.data.map((surgery) => ({
          id: surgery.id,
          title: surgery.title,
        }));
        this.$bvModal.show("modal-change-surgery");
      } catch (error) {
        console.error("Error fetching surgeries:", error);
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            variant: "danger",
            text: "Failed to fetch surgeries",
          },
        });
      } finally {
        this.loadingChangeSurgery = false;
      }
    },
    async submitChangeSurgery() {
      if (!this.selectedSurgery) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Validation Error",
            variant: "danger",
            text: "Please select a surgery",
          },
        });
        return;
      }

      this.loadingChangeSurgery = true;
      try {
        this.params.form = {
          surgery_id: this.selectedSurgery,
          _method: "PUT",
        };
        this.params.path = `/patient-surgery/${this.surgeries[this.surgeries.length - 1].id}`;

        await this.$store.dispatch("put", this.params);

        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Success",
            variant: "success",
            text: "Surgery changed successfully",
          },
        });

        this.$emit("refreshPatientCard");
        this.$bvModal.hide("modal-change-surgery");
      } catch (error) {
        if (error.response?.status === 400) {
          Object.keys(error.response.data).forEach((item) => {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Validation Error",
                variant: "danger",
                text: error.response.data[item][0],
              },
            });
          });
        }
      } finally {
        this.loadingChangeSurgery = false;
      }
    },
  },
};
</script>

<style scoped>
.mb-md-0 {
  margin-top: 8px;
}

.start-box {
  display: flex;
  flex-direction: column;
  align-items: start;
  margin: 0 1rem;
  position: absolute;
  right: 1%;
  top: -13.5%;
}

table {
  width: 94%;
  border: 1px solid;
  font-size: 11px;
}

.no-border {
  border: 0;
}

.square-dark {
  background-color: rgba(0, 0, 0, 0.2);
}

tr,
th,
td {
  border: 1px solid;
  width: 10px;
  height: 10px;
  text-align: center;
}

.font-modify {
  letter-spacing: normal !important;
}

.pdf-table {
  page-break-inside: avoid;
}

.square {
  width: 30px;
  /* Smaller width for squares */
  height: 30px;
  /* Smaller height for squares */
  background-color: #000;
  /* Color of the square */
  display: inline-block;
  /* Allows us to set width and height */
}

.centered-text {
  text-align: center;
  border: 2px solid #000;
  /* Border for the cell */
}

#table-above {
  border-collapse: collapse;
  /* Removes space between borders */
  font-size: 12px;
  /* Smaller font size for the entire table */
}

@media print {
  @page {
  }

  .pdf-table {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
}

.pdf-table:first-child {
  margin-top: 1em;
  /* Adjust the value as needed */
  page-break-inside: avoid;
}
.font-modify {
  letter-spacing: normal !important;
}
.rotated-text {
  transform: rotate(90deg);
  white-space: nowrap;
  text-align: center;
  color: #000;
  font-size: 12px;
}
</style>
